import { m as fetch } from './index2.js';
import { D as DomService } from './index3.js';

/* fetch has to be ponyfilled directly because of mocked node contexts during hydrate */
const TranslationService = {
    async fetchTranslation(endpoint) {
        if (!endpoint) {
            return {};
        }
        return fetch(endpoint)
            .then((result) => result.json(), () => ({}))
            .then((data) => {
            sessionStorage.setItem(endpoint, JSON.stringify(data));
            return data;
        }, () => ({}));
    },
    async getTranslation(locale, translationSourceUrl) {
        const { locale: defaultLocale, translationUrl } = DomService.getGlobalConfig();
        const url = translationSourceUrl || translationUrl;
        const localizedTranslationUrl = locale
            ? url === null || url === void 0 ? void 0 : url.replace(`${defaultLocale}.json`, `${locale}.json`)
            : url;
        const translation = JSON.parse(sessionStorage.getItem(`${localizedTranslationUrl}`)) || await this.fetchTranslation(localizedTranslationUrl);
        return translation || {};
    },
    async translate(key, locale, translationSource) {
        return (await this.getTranslation(locale, translationSource))[key] || key;
    },
};

export { TranslationService as T };

//# sourceMappingURL=index6.js.map